module.exports = __webpack_public_path__ + "static/media/transformational.900e09d6.png";